export default __webpack_public_path__ + "static/media/2507102.5c69908f.jpg";